import { useState } from "react";
import * as XLSX from "xlsx";
import ReactExport from "react-export-excel";
import CustomTable from "../../components/CustomTable";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  resetExcelMassiveUploadError,
  saveExcelMassiveUpload,
} from "../../redux/Headcount/ExcelMassiveUpload/actions";
import moment from "moment";
import toastr from "toastr";
import {
  resetAsistanceMassiveUpload,
  saveAsistanceMassiveUpload,
} from "../../redux/capacitacionDesarrollo/Training_assistance/actions";

const fixdata = (data) => {
  var o = "",
    l = 0,
    w = 10240;
  for (; l < data.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(data.slice(l * w, l * w + w))
    );
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
  return o;
};

const schema = Yup.object().shape({
  archivo_excel: Yup.string().required("**Campo requerido"),
});

function ModalMaciveEmployeeUpload(props) {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const dispatch = useDispatch();

  // states
  const [excelFileError, setExcelFileError] = useState(null);
  const [excelData, setExcelData] = useState(null);

  // variables redux
  const {
    loaderTrainingAssistanceUpload,
    trainingAssistanceUploadFail,
    trainingAssistanceUploadProblems,
  } = useSelector((store) => store.trainingAssistance);

  // table columns
  const columns = [
    {
      Header: "Id del evento",
      accessor: "id_evento",
    },
    {
      Header: "Código de empleado",
      accessor: "codigo_empleado",
    },
    {
      Header: "Asistió",
      accessor: "asistio",
    },
    {
      Header: "Id Motivo de inasistencia",
      accessor: "id_motivo_inasistencia",
    },
    {
      Header: "Horas recibidas",
      accessor: "horas_recibidas",
    },
  ];

  const columnsError = [
    {
      Header: "Id del evento",
      accessor: "id_evento",
    },
    {
      Header: "Código de empleado",
      accessor: "codigo_empleado",
    },
    {
      Header: "Asistió",
      accessor: "asistio",
    },
    {
      Header: "Id Motivo de inasistencia",
      accessor: "id_motivo_inasistencia",
    },
    {
      Header: "Horas recibidas",
      accessor: "horas_recibidas",
    },
    {
      Header: "Motivo de error",
      accessor: "motivo_error",
    },
  ];

  // handle File
  const fileType = [
    "application/vnd.ms-excel",
    "application/msexcel",
    "application/x-msexcel",
    "application/x-ms-excel",
    "application/x-excel",
    "application/x-dos_ms_excel",
    "application/xls",
    "application/x-xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const handleFile = (e) => {
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFileError(null);
          // setExcelFile(e.target.result);
          const arr = fixdata(e.target.result);
          const workbook = XLSX.read(btoa(arr), { type: "base64" });
          // console.log(workbook.SheetNames[2]);
          // const worksheetName = workbook.SheetNames[2];
          const worksheet = workbook.Sheets["Convocados"];
          const data = XLSX.utils.sheet_to_json(worksheet);
          // console.log(data);
          let _excelData = [];
          data.map((item) => {
            let codigoTemp = 8 - item.codigo_empleado.length;
            let _codigo_empleado = item.codigo_empleado;
            for (let i = 0; i < codigoTemp; i++) {
              _codigo_empleado = "0" + _codigo_empleado;
            }
            item.codigo_empleado = _codigo_empleado;
            _excelData.push(item);
          });
          setExcelData(_excelData);
          dispatch(resetExcelMassiveUploadError());
        };
      } else {
        setExcelFileError("Seleccione solo tipos de archivos de Excel.");
        // setExcelFile(null);
        setExcelData(null);
      }
    } else {
      setExcelFileError("Por favor seleccione su archivo.");
    }
  };

  // submit function
  const onSubmit = (req) => {
    if (!excelData) {
      setExcelFileError("Debe seleccionar solo tipos de archivos de Excel.");
      toastr.info("Debe seleccionar solo tipos de archivos de Excel", "", {
        progressBar: true,
        rtl: true,
      });
      return;
    }
    if (excelData.length === 0) {
      setExcelFileError("Debe seleccionar un archivo que contenga registros.");
      toastr.info("Debe seleccionar un archivo que contenga registros", "", {
        progressBar: true,
        rtl: true,
      });
      return;
    }
    setExcelFileError(null);
    let _excelData = [];
    excelData.map((excel) => {
      let exc = excel;
      exc.fecha = moment(exc.fecha).format("YYYY-MM-DD");
      let codigoTemp = 8 - exc.codigo_empleado.length;
      let _codigo_empleado = exc.codigo_empleado;
      for (let i = 0; i < codigoTemp; i++) {
        _codigo_empleado = "0" + _codigo_empleado;
      }
      exc.codigo_empleado = _codigo_empleado;
      _excelData.push(exc);
    });
    console.log(req);
    console.log(_excelData);
    dispatch(
      saveAsistanceMassiveUpload(
        _excelData,
        setExcelData,
        req,
        props.getTrainingAssistance,
        props.setShowModalMaciveUpload
      )
    );
  };

  return (
    <>
      <Modal
        show={props.showModalMaciveUpload}
        onHide={() => props.setShowModalMaciveUpload(false)}
        onShow={() => {
          setExcelData([]);
          dispatch(resetAsistanceMassiveUpload());
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">
            Excel Carga Masiva Convocados
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mx-2 d-flex flex-wrap justify-content-start align-items-center">
            <Col xs="auto">
              <h5 className="text-black-50">Plantilla:</h5>
            </Col>
            <ExcelFile
              element={
                <Button
                  id="buttonTemplate"
                  variant="light"
                  className="rounded-circle"
                  size="sm"
                >
                  <i className="material-icons">file_download</i>
                </Button>
              }
            >
              <ExcelSheet data={[{ id: props.id }]} name="Evento">
                <ExcelColumn label="id_evento" value="id" />
              </ExcelSheet>
              <ExcelSheet data={props.motivos} name="Motivos de inasitencia">
                <ExcelColumn label="id" value="id" />
                <ExcelColumn label="Motivo" value="descripcion" />
              </ExcelSheet>
              <ExcelSheet data={[]} name="Convocados">
                <ExcelColumn label="id_evento" value="id_evento" />
                <ExcelColumn label="codigo_empleado" value="codigo_empleado" />
                <ExcelColumn label="asistio" value="asistio" />
                <ExcelColumn
                  label="id_motivo_inasistencia"
                  value="id_motivo_inasistencia"
                />
                <ExcelColumn label="horas_recibidas" value="horas_recibidas" />
              </ExcelSheet>
            </ExcelFile>
          </Row>
          <div className="mb-4 mx-2">
            <hr />
          </div>
          <div className="mt-1 mb-2 mx-2 border-left border-warning">
            <Alert variant="light">
              <p>
                El documento debe ser de tipo de documento excel, debe tener una
                hoja llamada <b>Convocados</b> y debe contener los campos:{" "}
                <b>
                  id_evento, codigo_empleado, asistio, id_motivo_inasistencia y
                  horas_recibidas
                </b>
                .
              </p>
            </Alert>
          </div>

          {/* Sección de Súbida de archivo */}
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              archivo_excel: "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group as={Row} className="mx-2">
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.File
                          id="archivo_excel"
                          name="archivo_excel"
                          className="col position-relative my-2"
                          // disabled={!editItem.estado}
                          value={values.archivo_excel}
                          onChange={(e) => {
                            handleChange(e);
                            handleFile(e);
                          }}
                          onBlur={handleBlur("archivo_excel")}
                          isValid={
                            touched.archivo_excel && !errors.archivo_excel
                          }
                          isInvalid={
                            touched.archivo_excel && !!errors.archivo_excel
                          }
                        />
                      </Col>
                    </Row>
                    {touched.archivo_excel && errors.archivo_excel && (
                      <Col>
                        <small className="text-danger px-1">
                          {errors.archivo_excel}
                        </small>
                      </Col>
                    )}
                    {excelFileError && (
                      <Col>
                        <small className="text-danger px-1">
                          **{excelFileError}
                        </small>
                      </Col>
                    )}
                  </Col>
                  <Col sm={3}>
                    <Button
                      className="rounded-pill"
                      disabled={
                        loaderTrainingAssistanceUpload ||
                        props.loaderTrainingAssistance
                      }
                      variant="primary"
                      type="submit"
                    >
                      {loaderTrainingAssistanceUpload ||
                      props.loaderTrainingAssistance ? (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                      Cargar
                    </Button>
                  </Col>
                </Form.Group>
              </Form>
            )}
          </Formik>

          {/* view file section */}
          <div className="viewer">
            {loaderTrainingAssistanceUpload ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              <>
                {trainingAssistanceUploadProblems.length === 0 ? (
                  <>
                    {!!trainingAssistanceUploadFail && (
                      <Alert variant="danger" className="mt-1 mb-2 mx-2">
                        {trainingAssistanceUploadFail}
                      </Alert>
                    )}
                    {excelData && excelData.length > 0 ? (
                      <>
                        <Card className="border-0">
                          <Card.Body className="px-1 px-sm-2">
                            <CustomTable columns={columns} data={excelData} />
                          </Card.Body>
                        </Card>
                      </>
                    ) : (
                      <Alert variant="info" className="my-1 mx-2">
                        Aún no ha ingresado un documento excel
                      </Alert>
                    )}
                  </>
                ) : (
                  <>
                    {trainingAssistanceUploadProblems.length > 0 ? (
                      <>
                        <Alert variant="danger" className="mt-1 mb-2 mx-2">
                          Elementos con problema al cargar
                        </Alert>
                        <Card className="border-0">
                          <Card.Body className="px-1 px-sm-2">
                            <CustomTable
                              columns={columnsError}
                              data={trainingAssistanceUploadProblems}
                            />
                          </Card.Body>
                        </Card>
                      </>
                    ) : null}
                  </>
                )}
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => props.setShowModalMaciveUpload(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalMaciveEmployeeUpload;
